import Search from './InputSearch';

export default Search;
